import * as React from 'react'

function OffersBtnDecoration(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={49.335} height={66.738} viewBox="0 0 49.335 66.738" {...props}>
      <g data-name="Group 51998" transform="rotate(-174 19.99 22.78)">
        <circle
          data-name="Ellipse 1015"
          cx={5.685}
          cy={5.685}
          r={5.685}
          transform="translate(-12.607 -17.994)"
          fill="#fe5f55"
        />
        <circle
          data-name="Ellipse 1026"
          cx={4.422}
          cy={4.422}
          r={4.422}
          transform="translate(29.746 8.497)"
          fill="#d3dade"
        />
        <circle
          data-name="Ellipse 1025"
          cx={2.527}
          cy={2.527}
          r={2.527}
          transform="translate(12.684 40.87)"
          fill="#fe5f55"
        />
      </g>
    </svg>
  )
}

export default OffersBtnDecoration
